import { render, staticRenderFns } from "./UserInfoTitle.vue?vue&type=template&id=ded927f4&scoped=true"
import script from "./UserInfoTitle.vue?vue&type=script&lang=js"
export * from "./UserInfoTitle.vue?vue&type=script&lang=js"
import style0 from "./UserInfoTitle.vue?vue&type=style&index=0&id=ded927f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded927f4",
  null
  
)

export default component.exports